import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

@Injectable({
  providedIn: "root",
})
export class SendPushPlayerIdWS {
  constructor(private handler: BaseHandler) {}
  execute(deviceId: string, token: string): any {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.SEND_PUSH_PLAYER_ENDPOINT())
      .setMethod(HttpMethod.post)
      .setAuthorization(new TokenAuthorization(token))
      .setBody({
        player_id: deviceId,
      })
      .build();
    return this.handler.execute(parameters);
  }
}
